import X from './X'

export default X
// eslint-disable-next-line import/export
export * from './X'
